module.exports = __webpack_public_path__ + "static/urban_panning_image-af2f88017fae1756dc73d543be27ae74.jpg";